/*=========================================================================================
  File Name: state.js
  Description: Vuex Store - state
  ----------------------------------------------------------------------------------------
  Item Name: Pre-Pulse
  
==========================================================================================*/

import navbarSearchAndPinList from '@/layouts/components/navbar/navbarSearchAndPinList'
import themeConfig, { colors } from '@/../themeConfig.js'



// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
  taskList        : [],
  incidents       : {},
  callList        : [],
  currentIncidentID: "",
  attachedFiles   : [],
  fileUploadSettings: [],
  fileUploadQueue: [],
  claimSearch: [],
  claimSearchMax: 0,
  incidentNotes: [],
  claimLossPayments: [],
}

export default state
